import styled, { css } from 'styled-components';

import { ListCardStyle } from 'types';
import {
  bodySemibold,
  captionRegular,
  messagesRegular,
} from 'styles/mixins/fonts';

// Four tiles in a row; 2 x 2 on a phone. Inset 16px like the search bar and
// the rows below it; 16px above so the tiles' shadow is not cut by the tab's
// scroll area.
export const Summary = styled.div`
  gap: 16px;
  display: grid;
  padding-top: 16px;
  grid-auto-rows: 1fr;
  margin: 0 16px 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  ${({ theme }) =>
    theme.responsive.isMobile &&
    css`
      gap: 8px;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    `}
`;

export const Tile = styled.div<{ $emphasis?: boolean }>`
  min-width: 0;

  > * {
    height: 100%;
    border: 1px solid transparent;
  }

  ${({ theme, $emphasis }) =>
    $emphasis &&
    css`
      > * {
        border: ${theme.config.table[ListCardStyle.Default].selected.border};
      }
    `}
`;

export const TileTitle = styled.p`
  ${messagesRegular};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const TileValue = styled.h3<{ $emphasis?: boolean }>`
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  ${({ theme, $emphasis }) =>
    $emphasis &&
    css`
      color: ${theme.colors.blue.primary.standard};
    `}
`;

export const TileCaption = styled.p`
  ${captionRegular};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

// The list's rows sit in a 16px side inset; the total row gets the same.
export const Footer = styled.div`
  margin-top: 8px;
  padding: 0 16px;
`;

export const TotalText = styled.span`
  ${bodySemibold};
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;
